import React from 'react';
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { FEATURE_MATRIX } from '../../config/site';

export default function FeatureMatrix() {
  const renderCell = (value) => {
    if (typeof value === 'boolean') {
      return value ? (
        <CheckIcon color="success" />
      ) : (
        <CloseIcon color="disabled" />
      );
    }
    return value;
  };

  return (
    <Box sx={{ py: 8, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 4, fontWeight: 700 }}
        >
          Compare Features
        </Typography>

        <TableContainer component={Paper} elevation={2}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, minWidth: 200 }}>
                  Feature
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  Free
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: 700,
                    bgcolor: 'primary.light',
                    color: 'white',
                  }}
                >
                  Starter
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  Team
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {FEATURE_MATRIX.map((feature, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:nth-of-type(odd)': { bgcolor: 'grey.50' },
                    '&:hover': { bgcolor: 'grey.100' },
                  }}
                >
                  <TableCell>
                    <Tooltip title={`Details about ${feature.name}`} arrow>
                      <span>{feature.name}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="center">
                    {renderCell(feature.free)}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ bgcolor: 'primary.light', color: 'white' }}
                  >
                    {renderCell(feature.starter)}
                  </TableCell>
                  <TableCell align="center">
                    {renderCell(feature.team)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </Box>
  );
}
